import { Grid, Typography, useMediaQuery } from '@mui/material';

const Legends = () => {
  const legendData = [
    { label: 'Not Started', color: 'rgb(255, 69, 96)' },
    { label: 'Draft', color: 'rgb(254, 176, 25)' },
    { label: 'Submitted', color: 'rgb(0, 143, 251)' },
    { label: 'Approved', color: 'rgb(0, 227, 150)' },
    { label: 'Freezed', color: 'rgb(174, 174, 174)' },
  ];

  return (
    <Grid
      container
      display={'flex'}
      flexDirection={'column'}
      rowGap={1}
      sx={{
        border: '1px solid gray',
        height: '100%',
        maxWidth: '250px',
        py: 1,
        pl: 3,
        pr: 2,
        borderRadius: '4px',
      }}
    >
      {legendData.map(item => (
        <Grid container columnSpacing={1.5} item key={item.label}>
          <Grid item sx={{ background: item.color, borderRadius: '4px', width: 20, height: 20 }} />
          <Grid item>
            <Typography letterSpacing={1.5} variant="caption">
              {item.label}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default Legends;
